export default __webpack_public_path__ + "static/media/bgEllipse4.40f68745.svg";